module.exports = __webpack_public_path__ + "static/media/Calibre-Medium.115d3718.woff";